import {
  ShiftsSwapShiftOldFragment,
  SwapShiftsDocument,
  SwapShiftsQueryVariables,
} from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

import SwapShifts from 'modules/shift_management/store/internal/collections/SwapShifts'

interface Props {
  variables: SwapShiftsQueryVariables
  skip?: boolean
}

export const useSwapShifts = ({ variables, skip = false }: Props) => {
  const { loading, data, refetch } = useQuery(SwapShiftsDocument, { variables, skip })
  const swapShifts: ShiftsSwapShiftOldFragment[] = data
    ? data.shiftManagement.swapShiftsConnection.nodes
    : []

  const swapShiftsCollection = SwapShifts.buildFromRequestOld(swapShifts)

  return {
    refetch,
    loading,
    swapShiftsCollection,
  }
}
